import { createColumnHelper } from '@tanstack/react-table';

import Actions from './Actions';
import { Notification } from '@/client/features/notificationsystem/types';
import { formatIsoDate } from '@/utils/date';

const columnHelper = createColumnHelper<Notification>();

export const notificationRulesTable = [
  columnHelper.accessor('name', {
    header: 'Rule Name',
  }),
  columnHelper.accessor('created_at', {
    header: 'Created Date',
    cell: ({ getValue }) => formatIsoDate(getValue()),
  }),
  columnHelper.accessor('updated_at', {
    header: 'Last Updated',
    cell: ({ getValue }) => formatIsoDate(getValue()),
  }),
  columnHelper.accessor('count_triggered', {
    header: 'Triggered',
    meta: {
      alignment: 'numeric',
    },
  }),
  columnHelper.accessor('last_triggered', {
    header: 'Last Notification Sent',
    size: 250,
    cell: ({ getValue }) => formatIsoDate(getValue()),
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Actions',
    cell: ({ row }) => <Actions rule={row.original} />,
  }),
];
